import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import PageBase from 'components/common/PageBase';
import SearchPage from 'containers/search/SearchPage';

class ICNPage extends Component {
    render() {
        const { translate} = this.props;
        return (
            <PageBase title={translate('ICNForm.title')} showGoToButtons={false}>
                <div>
                    <SearchPage linkGoToDetails={"instantcrashalerts/details/"} showSingleExport={true} isIcnPlus={false} isDent={false}  />
                </div>
            </PageBase>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale).code
    };
}


export default connect(mapStateToProps)(ICNPage);


// WEBPACK FOOTER //
// ./src/pages/icn/ICNPage.js